<template lang="pug">
  v-dialog(v-model='dialogReporteTarifa' scrollable persistent max-width='100%')
    v-card
      v-card-text
        v-container(id="reporte")
          table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px")
            tr
              td(align="end")
                label(style="color: black; font-weight: bold; font-size: 15px") {{fechaActual}}
          p
          table(width='100%' cellspacing="0" align="center" style="padding: 0px 3px 3px 3px;'margin-top: -9px;")
            tr
              td
                h4(align="center" style="color: black; margin-top: 5px;") COMPARATIVO DE TARIFAS DE FLETES INTERNACIONALES
          table(border="1" width='100%' cellspacing="0" align="center")
            tr(style='background-color:#26a69a')
              td(align="center")
                div
                  span.header AGENCIA
              td(align="center")
                div
                  span.header NAVIERA
              td(align="center")
                div
                  span.header PAÍS DE ORIGEN
              td(align="center")
                div
                  span.header PUERTO DE ORIGEN
              td(align="center")
                div
                  span.header D.G.
              td(align="center")
                div
                  span.header FLETE
              td(align="center")
                div
                  span.header GASTOS LOCALES
              td(align="center")
                div
                  span.header TOTAL TARIFA
              td(align="center")
                div
                  span.header DÍAS LIBRES
              td(align="center")
                div
                  span.header SALIDA
              td(align="center")
                div
                  span.header TRÁNSITO
              td(align="center")
                div
                  span.header OBSERVACIÓN
            tr(v-for="(item, k) in tarifas" :key="k" align='center')
              td(align="start" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.agencia && item.agencia.nombreEmpresa') {{item.agencia.nombreEmpresa}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.naviera && item.naviera.nombreEmpresa') {{item.naviera.nombreEmpresa}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.pais && item.pais.pais') {{item.pais.pais}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.puerto') {{item.puerto}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div(v-if='item && (item.depositoG && item.depositoG > 0) && (item.estatusDepositoG && item.estatusDepositoG === "No Ex")')
                  span $ {{item.depositoG}} - {{item.estatusDepositoG}}
                div(v-else-if='item && (item.depositoG && (item.depositoG === 0 || item.depositoG > 0)) && (item.estatusDepositoG && item.estatusDepositoG === "Ex")')
                  span Exonerado
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.flete') $ {{item.flete}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.gastos') $ {{item.gastos}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.totalTarifa') $ {{item.totalTarifa}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.diasLibres') {{item.diasLibres}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.salida') {{item.salida}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.transito') {{item.transito}}
              td(align="center" valign='top' style="padding: 5px; color: black; font-size: 8px;")
                div
                  span(v-if='item && item.observacion') {{item.observacion}}
      v-card-actions
        v-btn(color='error' small dark @click='closeReporte')
          v-icon mdi-close
          | Cancelar
        v-spacer
        v-btn(color='success' small dark @click="imprimir()")
          v-icon mdi-content-save
          | Imprimir     
</template>

<script>
import printJS from 'print-js'
import { EventBus } from '../../Events'
export default {
  name: 'Reporte',
  props: ['dialogReporteTarifa'],
  data: () => ({
    fechaActual: '',
    tarifas: []
  }),
  
  watch: {},

  created () {
    EventBus.$on('reporteTarifa', data => {
      console.log('DATA', data)
      this.tarifas = data
      this.tarifas.map(data => {
        data.flete = parseFloat(data.flete)
        data.depositoG = parseFloat(data.depositoG)
        data.gastos = parseFloat(data.gastos)
        data.totalTarifa = parseFloat(data.totalTarifa)
        data.flete = (data.flete).toFixed(2)
        data.depositoG = (data.depositoG).toFixed(2)
        data.gastos = (data.gastos).toFixed(2)
        data.totalTarifa = (data.totalTarifa).toFixed(2)
      })
      var today = new Date()
      this.fechaActual = this.$moment(today).format('YYYY-MM-DD')
    })
  },

  methods: {
    imprimir () {
      printJS({
        printable: 'reporte',
        type: 'html',
        targetStyles: ['*'],
        maxWidth: '100%',
        documentTitle: 'Reporte',
        style: '@page { size: Letter landscape; }'
      })
      this.closeReporte()
    },

    closeReporte () {
      this.$emit('closeReporte')
    },

  }
}
</script>

<style lang="scss">
  #reporte {
    .header {
      font-size: 8px;
      color: black;
      font-weight: 850;
    }
  }
</style>
